import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function createSprint(payload) {
  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}admin/sprints`,
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function updateSprint(sprint_id, payload) {
  // admin/sprints/<sprint_id>
  return Vue.axios({
    method: "PUT",
    url: `${siteConfig.siteURL}admin/sprints/${sprint_id}`,
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function deleteSprint(id) {
  return Vue.axios({
    method: "DELETE",
    url: `${siteConfig.siteURL}admin/sprints/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getCalendar(cohort_id) {
  return Vue.axios({
    method: "GET",
    url: `${siteConfig.siteURL}admin/sprints/plan/${cohort_id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getCourse(id) {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}admin/courses/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}
